import { useEffect } from "react";

export function useScrollToAnchor() {
  useEffect(() => {
    const hash = window.location.hash;

    if (!hash) {
      return;
    }

    const element = document.querySelector(hash);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);
}
